<template>
  <div class="page-header-index-wide">
    <div style="padding: 10px">
      核酸情况
    </div>

      <a-row style="background: white;margin-bottom: 30px;padding: 30px;">

        <a-col :span="8">
          <a-card title="员工核酸结果" style="height: 200px;width: 300px;margin-left: 30px" >
            <div>
              <span style="font-size: 36px">{{this.homeData.negative}}</span>
              <span>人 阴性</span>
            </div>

          </a-card>
        </a-col>
        <a-col :span="8">
          <a-card title="员工核酸结果" style="height: 200px;width: 300px" >
            <div>
              <span style="font-size: 36px">{{this.homeData.positive}}</span>
              <span>人 阳性</span>
            </div>
          </a-card>
        </a-col>

      </a-row>
    <div style="padding: 10px">
      数据看板
    </div>
    <a-row >
      <a-col :span="8" :style="{ marginBottom: '24px',paddingRight:'24px' }">
        <a-card style="height: 500px" title="健康码态势" >
          <pie-color  :dataSource="healthCodeData" :midText="this.healthCodeTotal"/>

        </a-card>
      </a-col>
      <a-col  :span="8" :style="{ marginBottom: '24px',paddingRight:'24px' }">
        <a-card style="height: 500px" title="核酸态势" >
          <pie-color  :dataSource="nucleicData" :colorChange="true" :midText="this.nucleicTotal"/>
        </a-card>
      </a-col>
      <a-col :span="8" :style="{ marginBottom: '24px' }">
        <a-card style="height: 500px" title="超时预警">
          <div style="height: 350px;display: flex;justify-content: center;align-items: center;">
            <div>
              <div>
                接近72H人数
              </div>
              <div>
                <span style="font-size: 36px">{{this.homeData.between48And72}}</span>
                <span>人</span>
              </div>

            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <div style="padding: 10px">
      系统公告
    </div>

    <a-table
      ref="table"
      size="middle"
      :scroll="{x:1000}"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      class="j-table-force-nowrap"
      style="background: white"
     >
      <template slot="htmlSlot" slot-scope="text">
          <div v-if="text.includes('img')">图文内容</div>
          <div v-else v-html="$options.filters.setContent(text)"></div>
        </template>
       <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">查看</a>
        </span>
    </a-table>
    <!-- 查看详情 -->
    <j-modal class="detail-modal" title="查看详情" :visible.sync="detailModal.visible" :top="50" :width="600" switchFullscreen :footer="null">
      <iframe v-if="detailModal.url" class="detail-iframe" :src="detailModal.url"/>
    </j-modal>
    <show-announcement ref="ShowAnnouncement"></show-announcement>
  </div>
</template>

<script>
  import { getAction, postAction } from '@/api/manage'
  import PieColor from '@/components/chart/PieColor'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
   import ShowAnnouncement from '@/components/tools/ShowAnnouncement'
  export default {
    name: 'Home',
    components:{
      PieColor,
      ShowAnnouncement
    },
    data() {
      return {
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title:'标题',
            align:"center",
            dataIndex: 'titile',
            width:400,
            ellipsis:true,
          },
          {
            title:'内容',
            align:"center",
            dataIndex: 'msgContent',
            width:500,
            ellipsis:true,
            scopedSlots: {customRender: 'htmlSlot'},
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'sendTime'
          },
          {
            title:'发布人',
            align:"center",
            dataIndex: 'sender'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
        healthCodeData:[],
        nucleicData:[],
        dataSource:[],
        detailModal: {visible: false, url: '',},
        homeData:{},
        healthCodeTotal: 0,
        nucleicTotal: 0,
      }
    },
    created() {
      this.getIndexData()
      this.getAnnountCement()
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },

    methods: {
      getIndexData() {
        getAction('/prevent/h5/index',{factory:''}).then((res) => {
          if (res.success) {
            this.homeData = res.result;

            
           this.healthCodeData.push({item: '绿码', count: this.homeData.green });
            
           
              this.healthCodeData.push({item: '黄码', count: this.homeData.yellow });
            
          
              this.healthCodeData.push({item: '红码', count: this.homeData.red });
          

            this.healthCodeTotal = this.homeData.green + this.homeData.yellow +  this.homeData.red

           
              this.nucleicData.push({item: '24H', count: this.homeData.lessThen24 });
           
           
              this.nucleicData.push({item: '48H', count: this.homeData.between24And28 });
           
           
              this.nucleicData.push({item: '72H', count: this.homeData.between48And72 });
           
            
              this.nucleicData.push({item: '>72H', count: this.homeData.moreThen72 });
           

            this.nucleicTotal = this.homeData.lessThen24 + this.homeData.between24And28 + this.homeData.between48And72 + this.homeData.moreThen72

            this.$forceUpdate()

            console.log('healthCodeTotal : ',this.healthCodeTotal)
            console.log('nucleicTotal : ',this.nucleicTotal)
          }
        })
      },
      getAnnountCement() {
        let appId = this.$store.getters.application.id;
        if(appId === undefined) {
          appId = '1526828958439706625'
        }
        getAction('/sys/annountCement/queryList',{applicationId:appId,msgCategory:1,sendStatus:1}).then((res) => {
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          });
          this.dataSource.map(item => {

            // if(item.msgContent != null) {
            //    item.msgContent = item.msgContent.replace(/<p>/g,"").replace("</p>","")
            // }                  
          })
          this.dataSource = this.dataSource.slice(0,5)
        })
      },
      handleDetail:function(record){
        this.$refs.ShowAnnouncement.detail(record);
      },

    },
     filters: {
      //当渲染的文字超出一定字节后显示省略号
      setContent(value) {
        if (!value) return "";
        if (value.length > 60) {
          return value.slice(0, 60) + "......";
        }
        return value;
      }
    }

  }
</script>

<style scoped lang="less">
  @import '~@assets/less/common.less';

   /** 查看详情弹窗的样式 */
  .detail-modal {
    .detail-iframe {
      border: 0;
      width: 100%;
      height: 88vh;
      min-height: 600px;
    }

    &.fullscreen .detail-iframe {
      height: 100%;
    }
  }

  .detail-modal /deep/ .ant-modal {
    top: 30px;

    .ant-modal-body {
      font-size: 0;
      padding: 0;
    }
  }

  .detail-modal.fullscreen /deep/ .ant-modal {
    top: 0;
  }

</style>
